import { Injectable, EventEmitter, Inject, isDevMode } from '@angular/core';
import { Http, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { TokenHttp } from '../services/tokenhttp.service';
import { BootConstants } from '../boot.constants';
import { IChangePassword } from '../interfaces/IChangePassword';
import { map } from 'rxjs/operators';
import { BaseRepository } from './base.repository';
import { ICarrier } from '../interfaces/ICarrier';
import { IDriver } from '../interfaces/IDriver';
import { ICarrierAccess } from '../interfaces/ICarrierAccess';
;

@Injectable()
export class CarrierRepository extends BaseRepository {

  constructor(tokenHttp: TokenHttp) {
    super(tokenHttp);
  }

  public getAll(): Observable<ICarrier[]> {
    return this.mapGet("carriers");
  }

  public getById(id: number): Observable<ICarrier> {
    return this.mapGet("carriers/" + id);
  }

  public getDrivers(id: number): Observable<IDriver[]> {
    return this.mapGet("carriers/" + id + "/drivers");
  }

  public getDetails(): Observable<ICarrier> {
    return this.mapGet("carrier");
  }

  public getAccess(id: number): Observable<ICarrierAccess> {
    return this.mapGet("carriers/" + id + "/access");
  }

  public createAccess(id: number, access: ICarrierAccess): Observable<ICarrierAccess> {
    return this.mapPost("carriers/" + id + "/access", access);
  }

  public updateAccess(id: number, access: ICarrierAccess): Observable<ICarrierAccess> {
    return this.mapPut("carriers/" + id + "/access", access);
  }

  public removeAccess(id: number): Observable<void> {
    return this.mapDelete("carriers/" + id + "/access");
  }
}
